<template>
  <div class="recreation">
    <!-- 搜索导航 -->
    <nav-bar @search="search"></nav-bar>

    <!-- banenr列表 -->
    <banner-list :banners="bannerList"></banner-list>
    <div class="recreation-wrapper">
      <!-- <div class="title">所有权益</div> -->
      <!-- sku 列表 -->
      <div class="recreation-product" v-show="productList.length">
        <list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <skulist :sku-list="productList"></skulist>
        </list>
      </div>
      <!-- 无数据状态 -->
      <NoData v-show="noData && !productList.length" />
    </div>
    <!-- 回主页 -->
    <GoHome />

    <transition name="fade-in">
      <keep-alive>
        <component :is="componentId" @close="closeSearch"></component>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import { List } from 'vant'
import NavBar from '../../components/NavBarForRights'
import Search from '../../components/SearchForProduct'
import BannerList from '../../components/RightsMall/BannerList'
// import Skulist from '../../components/RightsMall/RightsSkuList'
import Skulist from '../../components/ProductDoubleEach'
import GoHome from '../../components/RightsMall/GoHome'
import NoData from '../../components/RightsMall/noData'
import { mapState } from 'vuex'
let flag = false
export default {
  name: 'recreation',
  components: {
    NavBar,
    Search,
    List,
    BannerList,
    Skulist,
    GoHome,
    NoData
  },
  data () {
    return {
      cid: 0,
      componentId: null,
      loading: false,
      finished: false,
      pageNum: 1,
      totalCont: 0,
      productList: [],
      noData: false,
      bannerList: []
    }
  },
  computed: {
    ...mapState('store', ['Authorization'])
  },
  created () {
    this.$toast.loading({
      message: '正在加载...',
      duration: 30000
    })
    this.getBannnerList()
    this.getProductColumn()
  },
  methods: {
    search () {
      this.componentId = Search
    },
    closeSearch () {
      this.componentId = null
    },

    /**
     * 分页加载
     */
    onLoad () {
      if (flag) {
        return
      }
      flag = true
      setTimeout(() => {
        this.getProductList(++this.pageNum).then(() => {
          this.loading = false
          flag = false
        })
      }, 1000)
    },
    /**
     * 获取商品列表
     */
    async getProductList (pageNum) {
      const res = await this.$axios.get(
        `/api/goods/channelItems/${this.cid}/${pageNum || 1}`
      )
      if (res.status === 200) {
        this.$toast.clear()
        const { code, data, msg, count } = res.data
        if (code === 0) {
          this.totalCont = count
          this.productList = [...this.productList, ...data]
        } else if (code === 9006) {
          this.finished = true
          if (pageNum === 1) {
            this.noData = true
          }
        } else {
          this.$toast(msg)
        }
      }
    },

    async getBannnerList () {
      const res = await this.getInit('ylhome-1')
      if (res.status === 200) {
        const { code, msg, data } = res.data
        if (code === 0) {
          this.bannerList = data
        } else {
          this.$toast(msg)
        }
      }
    },
    /**
     * 获取商品列表栏目id
     */
    async getProductColumn () {
      const res = await this.getInit('ylhome-2')
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg, data } = res.data
        if (code === 0) {
          this.cid = data[0].configer.column
          this.getProductList()
        } else {
          this.$toast(msg)
        }
      }
    },
    /**
     * 获取页面位置详情
     * @params {String} code 页面位置编码
     */
    getInit (code) {
      return this.$axios.get(`api/shop/customize/${code}`)
    }
  }
}
</script>

<style lang="less" scoped>
.recreation {
  background: #fff;
  font-size: @fz28;
  padding-bottom: 0.5rem;
}
.recreation-top {
  background-color: #fff;
  width: 100%;
  height: 0.88rem;
}
.banner {
  width: 100%;
  height: 2.54rem;
  margin-bottom: 0.2rem;
  &:last-child {
    margin-bottom: 0;
  }
  img {
    width: 100%;
    height: 100%;
  }
}
.recreation-wrapper {
  padding: 0.2rem;
  .title {
    margin: 0.4rem 0 0.82rem;
    margin-left: 0.18rem;
    padding-left: 0.16rem;
    font-size: @fz28;
    border-left: 0.07rem solid #0880b0;
    line-height: 1;
  }
}
</style>
